module.exports = __webpack_public_path__ + "img/icon-cal-comment.d7fbcd5b.svg";